export default __webpack_public_path__ + "static/media/cyber-security.8f4f94a5.gif";